import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
const OnboardingPage = lazy(() => import('./onboarding.page'));

export const OnboardingRoutes = () => {
  const [newOnboardingExperience] = useFeatureFlag('NEW_ONBOARDING_EXPERIENCE');
  return (
    <Routes>
      {newOnboardingExperience && (
        <Route path="/" element={<OnboardingPage />} />
      )}
    </Routes>
  );
};
